import type { ConsultationDestinationType } from '#core/utils/consultation-destination'
import { resolveConsultationDestination } from '#core/utils/consultation-destination'

export function useConsultationDestination(consultationType: ConsultationDestinationType = 'project') {
  const destination = computed(() => resolveConsultationDestination(consultationType))

  async function openConsultation() {
    await navigateTo(destination.value.to)
  }

  return { destination, openConsultation }
}
